<template>
	<div id="cgg_reg" class="comform">
		<form>
			<p><img :src="logo" /></p>
			<div class="pwd cominpput">
				<span><img src="/static/loph.png" /></span>
				<input type="text" name="mobile" id="mobile" v-model="mobile" placeholder="请输入手机号" />
			</div>
			<div class="conpwd cominpput">
				<span><img src="/static/ys.png" /></span>
				<input type="text" name="rand" id="checkCode" v-model="checkCode" placeholder="请输入验证码" maxlength="6" class="wid_50" />
				<p class="line"></p>
				<input class="code " name='b' readonly @click="sendSms" v-model="text" />
			</div>
			<a class="btn" @click="login()">登录</a>
			<p class="font_28 last">请在60秒内完成验证，超时请点击重新发送</p>
		</form>
	</div>
</template>

<script>
import {
  Auth_Login,
  Auth_IsLogin,
  Auth_SendSms
} from "@/api/api.js"

export default {
  data () {
    return {
		mobile:'',
		checkCode:'',
		text:'获取验证码',
		issending:false,
		logo:''

    }
  },
  methods:{
	  login:function(){
		  let that = this;
		  Auth_Login({mobile:that.mobile,checkCode:that.checkCode},function(res){
			if(res.code == 200){
		  		location.href = '/wechat/home';
			}
			else{
				alert(res.message);
			}
		  })
	  },
	  sendSms:function(){
		  let that = this;
		  if(that.issending){return;}
		  that.issending = true;
		  if(that.text != "获取验证码"){return;}
		  if(!that.mobile){return;}
		  Auth_SendSms({mobile:that.mobile},function(res){
			  that.issending = false;
			if(res.code == 200){
				let times = 60;
				let timer = setInterval(function(){
					that.text=`${times}秒后重试`;
					times--;
					if(times <= 0){
						clearInterval(timer);
						that.text="获取验证码";
					}
				},1000)
			}
			else{
				alert(res.message);
			}
		  })
	  },
  },
  created:function(){
	let that = this;
	if(location.hostname == 'hy.xiaoqinhaishen.com')
	that.logo = 'cgglogo.png';
	else if(location.hostname == 'hy.shengongshiye.com')
	that.logo = 'cgglogosh.png';
	Auth_IsLogin({},function(res){
	if(res.code == 200){
		location.href = '/wechat/home';
	}
	})
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/wechat/index.vue